import React, { useEffect, useState } from "react";
import classes from "./ReviewSidebar.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { Button } from "../Button/Button";
import { ReviewsOnSidebar } from "../ReviewsOnSidebar/ReviewsOnSidebar";
import PropTypes from "prop-types";

export const ReviewSidebar = (props) => {
  const { data } = props.data;
  const { totalRating, rating, reviewTypes } = props.data.review;

  return (
    <div
      style={{
        backgroundColor: Colors.neutralShadesOfWhiteSmoke,
        height: "100%",
        width: "100%",
      }}
      className={classes.sidebarContainer}
    >
      <ReviewsOnSidebar
        rating={rating}
        totalRating={totalRating}
        reviewTypes={reviewTypes}
      />

      {/* Border After Header */}
      <p
        className={[classes.mb32].join(" ")}
        style={{ borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}` }}
      ></p>

      {/* Students Reactions */}

      <p
        style={{
          ...Fonts.h6,
          color: Colors.neutralShadesOfNero,
        }}
        className={[classes.mb16].join(" ")}
      >
        Here’s what your students say about you
      </p>

      {/* Tags */}
      <div className={classes.tagsContainer}>
        {data?.studentsSayings?.map((item) => {
          return (
            <span>
              <Button
                label={item}
                customStyle={{
                  ...Fonts.p2,
                  padding: "8px 16px 8px 16px",
                  width: "max-content",
                }}
              />
            </span>
          );
        })}
      </div>
    </div>
  );
};

ReviewSidebar.propTypes = {
  data: PropTypes.object,
  //   onClick: PropTypes.func,
};

ReviewSidebar.defaultProps = {
  data: {
    studentsSayings: [
      "Friendly to kids",
      "Competitive",
      "Discipline",
      "Caring",
    ],
  },
};
